import script from "./DaoAccountCreation.vue?vue&type=script&setup=true&lang=js"
export * from "./DaoAccountCreation.vue?vue&type=script&setup=true&lang=js"

import "./DaoAccountCreation.vue?vue&type=style&index=0&id=706ad004&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-706ad004"]])

export default __exports__